import authReducer from "store/slices/auth.slice";
import useReducer from "store/slices/user.slice";
import searchReducer from "store/slices/searcSlice";
import projectReducer from "store/slices/projectSlice";
import mediaRecorderReducer from './mediaRecorderSlice';
import talentPoolReducer from "./talentPool";
import projectSlice from "store/slices/projectSlice";
import candidateScreeningSlice from "./candidateScreening";
import analyticsReducer from "./analyticsSlice";
import refreshReducer from "./refresh.slice";
import filtercriteriaReducer from "./filtercriteria.slice";
import candidateBulkMail from "./candidateBulkMail.slice";
import reportSlice from "./reports.slice";

const reducer = {
  auth: authReducer,
  user: useReducer,
  search: searchReducer,
  project: projectReducer,
  mediaRecorder: mediaRecorderReducer,
  talentPool: talentPoolReducer,
  projectSlice: projectSlice,
  candidateScreening: candidateScreeningSlice, 
  analytics: analyticsReducer,
  refresh: refreshReducer,
  filtercriteria: filtercriteriaReducer,
  candidateBulkMail: candidateBulkMail,
  reportSlice: reportSlice,
};

export default reducer;
